import {
  ButtonBase,
  ThemeProvider,
  theme,
  TwoColumnSectionBase,
  BadgeBase,
  ImageOverlay,
} from "@reusejs/react";
import {
  XIcon,
  BadgeCheckIcon,
  ClipboardCheckIcon,
  ExternalLinkIcon,
} from "@heroicons/react/solid";
import Rapco from "../../Icons/Rapco";
import Logo from "../../layouts/header/Logo";
import WhatsAppIcon from "../../Icons/WhatsAppIcon";
import RapcoHomeIcon from "../../Icons/RapcoHomeIcon";
import { getWatermarkedImgixUrl } from "services";

export default function BannerPopup(props: any) {
  const newTheme = {
    ...theme,
    variants: {},
  };

  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div className="flex justify-between bg-gray-50 items-center px-4 py-3 border-b text-base text-gray-900">
            <div>Upcoming Event</div>
            <div
              className="cursor-pointer"
              onClick={() => props.onAction("no")}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <TwoColumnSectionBase
            firstColumnEl={
              <div className="space-y-3">
                <Logo />
                <div className="text-gray-900 text-3xl font-bold mb-4">
                  Mega e-Auction!
                </div>
                <BadgeBase
                  label={"Credible seller"}
                  badgePrefix={
                    <BadgeCheckIcon width="12" height="13" className="mr-1" />
                  }
                  badgeBaseClasses={{
                    padding: "px-2 py-0.5",
                    backgroundColor: "bg-green-50 mr-2",
                    textColor: "text-green-600",
                    font: "text-xs font-medium",
                    borderRadius: "rounded-md",
                  }}
                />
                <BadgeBase
                  label={"Clear title"}
                  badgePrefix={
                    <ClipboardCheckIcon
                      width="12"
                      height="13"
                      className="mr-1"
                    />
                  }
                  badgeBaseClasses={{
                    padding: "px-2 py-0.5",
                    backgroundColor: "bg-blue-50",
                    textColor: "text-blue-600",
                    font: "text-xs font-medium",
                    borderRadius: "rounded-md",
                  }}
                />
                <div className="text-base text-gray-700 font-light">
                  Grab the golden opportunity to participate in the e-auction
                  hosted by AuctionBazaar.com in association with Repco Home
                  Finance Ltd.
                </div>
                <div className="text-base text-gray-700 font-bold">
                  Mark the dates in your calendar:
                </div>
                <div className="text-base text-gray-700 font-light">
                  EMD last date:
                  <span className="font-medium"> Jan 23rd, 2023</span>
                </div>
                <div className="text-base text-gray-700 font-light">
                  Auction date:
                  <span className="font-medium"> Jan 24th, 2023</span>
                </div>
                <div className="pt-4 flex w-full flex-col sm:flex-row sm:justify-between">
                  <ButtonBase
                    variant="primary"
                    type="submit"
                    label="Explore Now"
                    onClick={() => {
                      props.router.push(
                        "/auction-properties-by-repco-home-finance-limited",
                      );
                      props.onAction("no");
                    }}
                    buttonPrefix={
                      <ExternalLinkIcon
                        width={24}
                        height={24}
                        className="mr-1"
                      />
                    }
                    buttonBaseClasses={{
                      font: "text-base font-semibold",
                      backgroundColor: "bg-blue-600 hover:bg-blue-700 mb-2",
                      textColor: "text-white",
                      border: "any",
                      width: "w-44",
                      padding: "px-2 py-2",
                    }}
                  />

                  <ButtonBase
                    variant="primary"
                    type="submit"
                    label="WhatsApp Me"
                    onClick={() => {
                      const clientNumber = "+918370969696";
                      const baseurl = window.location.href
                        .split("/")
                        .filter(Boolean)[1];
                      const link =
                        "http://" +
                        baseurl +
                        "/auction-properties-by-repco-home-finance-limited";
                      const whatsappMsg = `Hi Auctionbazaar,\n\nI am interested in knowing more about this property\n\n${link}`;

                      window.open(
                        `https://wa.me/${clientNumber}?text=${encodeURI(
                          whatsappMsg,
                        )}`,
                        "_blank",
                      );
                    }}
                    buttonPrefix={
                      <div className="mr-1">
                        <WhatsAppIcon />
                      </div>
                    }
                    buttonBaseClasses={{
                      font: "text-base font-semibold",
                      backgroundColor: "bg-[#40C351] hover:bg-green-700 mb-2",
                      textColor: "text-white",
                      border: "any",
                      width: "w-44",
                      padding: "px-2 py-2",
                    }}
                  />
                </div>
              </div>
            }
            secondColumnEl={
              <div className="bg-rapco-pattern bg-no-repeat bg-center h-full rounded-md p-2 sm:p-6">
                <div className="bg-white h-full overflow-hidden rounded-md shadow-md p-4">
                  <div className="w-full rounded-2xl overflow-hidden">
                    <ImageOverlay
                      src={getWatermarkedImgixUrl(
                        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/e62fe6b0-506b-4ed6-b30b-a7090009d714?fit=fill&auto=format`,
                      )}
                      width={248}
                      height={236}
                      effectClasses=""
                      altName={"banner-rapco"}
                      bottomLeft={
                        <BadgeBase
                          label="50+ Properties"
                          badgeBaseClasses={{
                            padding: "px-3 py-1",
                            backgroundColor: "bg-white",
                            textColor: "text-gray-900",
                            font: "text-xs font-semibold",
                            borderRadius: "rounded-2xl",
                          }}
                          badgePrefix={
                            <div className="mr-2">
                              <RapcoHomeIcon />
                            </div>
                          }
                        />
                      }
                    />
                  </div>
                  <BadgeBase
                    label="HOUSES"
                    badgeBaseClasses={{
                      padding: "px-3 py-1",
                      backgroundColor: "bg-green-50 mt-4 mr-2",
                      textColor: "text-black",
                      font: "text-sm font-medium",
                      borderRadius: "rounded-lg",
                    }}
                    badgePrefix={
                      <div className="mr-2 text-green-700">&#9679;</div>
                    }
                  />
                  <BadgeBase
                    label="FLATS"
                    badgeBaseClasses={{
                      padding: "px-3 py-1",
                      backgroundColor: "bg-purple-50",
                      textColor: "text-black",
                      font: "text-sm font-medium",
                      borderRadius: "rounded-lg",
                    }}
                    badgePrefix={
                      <div className="mr-2 text-purple-700">&#9679;</div>
                    }
                  />
                  <BadgeBase
                    label="PLOTS"
                    badgeBaseClasses={{
                      padding: "px-3 py-1",
                      backgroundColor: "bg-yellow-50 mt-4",
                      textColor: "text-black",
                      font: "text-sm font-medium",
                      borderRadius: "rounded-lg",
                    }}
                    badgePrefix={
                      <div className="mr-2 text-orange-700">&#9679;</div>
                    }
                  />
                </div>
              </div>
            }
            twoColumnSectionBaseClasses={{
              firstElWrapperStyles: "w-full md:w-1/2 mt-4",
              secondElWrapperStyles:
                "w-full md:w-1/2 mt-4 sm:mt-0 self-stretch sm:pl-8",
              columnsFlexWrapperStyles:
                "flex justifyF-between flex-col md:flex-row p-6",
            }}
          />

          <div className="border-t h-20 px-6 py-4 gap-x-2 text-gray-700 text-xs flex items-center">
            In Association with:
            <Rapco />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
